import { TAGS } from "../constants";
import { PatientRating, RatingStatus } from "../types";
import { api } from "./api";

export const patientRatingsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientRatings: builder.query<
      PatientRating[],
      { patient_id?: number; status?: RatingStatus }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient-ratings`,
        params,
      }),
      providesTags: [TAGS.PATIENT_RATINGS],
    }),
  }),
});

export const { useGetPatientRatingsQuery } = patientRatingsApi;
